module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker(1).ab2ca55e.gif";